<template>
  <div class="file-upload-block-paddings">
    <BaseChecklistFormBlock
      :title="block.title || 'Attachment'"
      :required="block.required"
      :invalid="block.required && !hasFileUploaded"
    >
      <div
        class="gap-column-1xs qrw-text-content-base-secondary"
        v-if="!hasFileUploaded"
      >
        <BaseIcon icon="paperclip" size="sm2" />
        {{ $t("checklist_report_blocks.no_file") }}
      </div>

      <div class="uploaded-file qrw-box-shadow-1dp" v-else>
        <div class="uploaded-file-left w-100">
          <BaseIcon style="font-size: 36px" icon="image" />
          <div class="gap-row-zero w-100">
            <div class="qrw-text-content-base-primary qrw-label-md">
              {{ block.file_upload.name }}
            </div>
            <div class="qrw-text-content-base-secondary qrw-label-md">
              {{ prettyFileSize }}
            </div>
          </div>
          <a :href="block.file_upload.url" target="_blank">
            <BaseIconButton
              icon="eye"
              variant="ghost"
              textColor="content-base-tertiary"
              size="md"
            />
          </a>
        </div>
      </div>
    </BaseChecklistFormBlock>
  </div>
</template>

<script>
import BaseChecklistFormBlock from "./BaseChecklistFormBlock.vue";

//TODO: move to common package
function formatFileSize(bytes) {
  if (!bytes) return `0 B`;

  let value = bytes;
  let suffix = "B";

  if (value > 1024 * 1024) {
    suffix = "MB";
    value = Math.round(value / (1024 * 1024));
  } else if (value > 1024) {
    suffix = "KB";
    value = Math.round(value / 1024);
  }

  return `${value} ${suffix}`;
}

export default {
  props: {
    block: Object,
    form: Object,
    metadata: Object,
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    prettyFileSize() {
      if (!this.block.file_upload) return;
      return formatFileSize(this.block.file_upload.size);
    },
    hasFileUploaded() {
      return this.block.file_upload && this.block.file_upload.url;
    },
  },
  methods: {},
  components: {
    BaseChecklistFormBlock,
  },
};
</script>

<style scoped>
.file-upload-block-paddings {
  display: flex;
  padding: 16px 12px;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
}

.uploaded-file {
  display: flex;
  flex-direction: row;
  border-radius: 6px;
  align-items: center;
  column-gap: 4px;
  background: var(--qrw-background-base-primary);
  padding: 4px;
}

.uploaded-file-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 6px;
}
</style>
